import React, { useEffect, useRef } from "react";
import tpsitePfpMPatel from "url:../images/tpsitePfpMPatel.png";
import tpsitePfpMThrasher from "url:../images/tpsitePfpMThrasher.png";
import tpsitePfpJClements from "url:../images/tpsitePfpJClements.png";
import tpsitePfpSChaney from "url:../images/tpsitePfpSChaney.png";
import tpsitePfpJShirling from "url:../images/tpsitePfpJShirling.png";
import tpsitePfpKLindsay from "url:../images/tpsitePfpKLindsay.png";
import tpsitePfpMDebs from "url:../images/tpsitePfpMDebs.png";
import tpsitePfpSSteen from "url:../images/tpsitePfpSSteen.png";
import tpsitePfpARobben from "url:../images/tpsitePfpARobben.png";
import tpsitePfpLFouts from "url:../images/tpsitePfpLFouts.png";
import tpsitePfpJEason from "url:../images/tpsitePfpJEason.png";
import tpsitePfpJJohnson from "url:../images/tpsitePfpJJohnson.png";
import tpsitePfpJMontag from "url:../images/tpsitePfpJMontag.png";
import tpsitePfpZWatkins from "url:../images/tpsitePfpZWatkins.png";
import tpsitePfpDGreen from "url:../images/tpsitePfpDGreen.png";
import tpsitePfpJLittle from "url:../images/tpsitePfpJLittle.png";
import tpsitePfpADino from "url:../images/tpsitePfpADino.png";
import tpsitePfpDDiener from "url:../images/tpsitePfpDDiener.png";
import tpsitePfpHBailey from "url:../images/tpsitePfpHBailey.png";
import tpsitePfpSDAngelo from "url:../images/tpsitePfpSDAngelo.png";
import tpsitePfpBTillman from "url:../images/tpsitePfpBTillman.png";
import tpsitePfpCBrauer from "url:../images/tpsitePfpCBrauer.png";
import tpsitePfpJDavenport from "url:../images/tpsitePfpJDavenport.png";
import tpsitePfpKHarrison from "url:../images/tpsitePfpKHarrison.png";
import tpsitePfpNAkula from "url:../images/tpsitePfpNAkula.png";
import tpsitePfpPhutson from "url:../images/tpsitePfpPhutson.png";

const team = [
  { name: "Manish Patel", title: "CEO & Founder", img: tpsitePfpMPatel },
  { name: "Michael Thrasher", title: "Developer & Consultant", img: tpsitePfpMThrasher },
  { name: "Billups Tillman", title: "Developer & Consultant", img: tpsitePfpBTillman },
  { name: "Josh Clements", title: "Developer & Consultant", img: tpsitePfpJClements },
  { name: "Steven Chaney", title: "Developer & Consultant", img: tpsitePfpSChaney },
  { name: "Jeff Shirling", title: "Developer & Consultant", img: tpsitePfpJShirling },
  { name: "Kevin Lindsay", title: "Developer & Consultant", img: tpsitePfpKLindsay },
  { name: "Michael Debs", title: "Developer & Consultant", img: tpsitePfpMDebs },
  { name: "Sebastian Steen", title: "Developer & Consultant", img: tpsitePfpSSteen },
  { name: "Amy Robben", title: "Developer & Consultant", img: tpsitePfpARobben },
  { name: "Lexi Fouts", title: "Developer & Consultant", img: tpsitePfpLFouts },
  { name: "Jordan Eason", title: "Developer & Consultant", img: tpsitePfpJEason },
  { name: "Jordan Johnson", title: "Developer & Consultant", img: tpsitePfpJJohnson },
  { name: "Josh Montag", title: "Developer & Consultant", img: tpsitePfpJMontag },
  { name: "Zach Watkins", title: "Developer & Consultant", img: tpsitePfpZWatkins },
  { name: "Dustin Green", title: "Developer & Consultant", img: tpsitePfpDGreen },
  { name: "John Little", title: "Developer & Consultant", img: tpsitePfpJLittle },
  { name: "Alec Dino", title: "Developer & Consultant", img: tpsitePfpADino },
  { name: "Dylan Diener", title: "Developer & Consultant", img: tpsitePfpDDiener },
  { name: "Hunter Bailey", title: "Developer & Consultant", img: tpsitePfpHBailey },
  { name: "Stephen D'Angelo", title: "Developer & Consultant", img: tpsitePfpSDAngelo },
  { name: "Calvin Brauer", title: "Developer & Consultant", img: tpsitePfpCBrauer },
  { name: "Jerrod Davenport", title: "Developer & Consultant", img: tpsitePfpJDavenport },
  { name: "Kyle Harrison", title: "Developer & Consultant", img: tpsitePfpKHarrison },
  { name: "Nithya Akula", title: "Developer & Consultant", img: tpsitePfpNAkula },
  { name: "Patrick Hutson", title: "Developer & Consultant", img: tpsitePfpPhutson },
];

function Team() {
  const swiperEl = useRef(null);

  useEffect(() => {
    if (window.Swiper && swiperEl.current) {
      new window.Swiper(swiperEl.current, {
        speed: 600,
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        slidesPerView: "auto",
        pagination: { el: ".swiper-pagination", type: "bullets", clickable: true },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 20 },
          640: { slidesPerView: 2, spaceBetween: 20 },
          992: { slidesPerView: 3, spaceBetween: 20 }
        }
      });
    }
  }, []);

  return (
    <section id="our-team" className="testimonials section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Our Team</h2>
          <p>
            Meet the dedicated individuals who make up the heart and soul of our company. 
            Our employees are a diverse and talented group, working together to bring 
            innovation and excellence to everything we do.
          </p>
        </div>
        <div ref={swiperEl} className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="300">
          <div className="swiper-wrapper">
            {team.map((person, i) => (
              <div key={i} className="swiper-slide">
                <div className="testimonial-item">
                  <img src={person.img} className="testimonial-img" alt={person.name} />
                  <h3>{person.name}</h3>
                  <h4>{person.title}</h4>
                </div>
              </div>
            ))}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
}

export default Team;
